// ko translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const ko = {
    // Common
    "common.loading": "로딩 중...",
    "common.save": "저장",
    "common.cancel": "취소",
    "common.delete": "삭제",
    "common.edit": "편집",
    "common.submit": "제출",
    "common.logout": "로그아웃",
    "common.login": "로그인",
    "common.register": "등록",
    
    // Auth
    "auth.welcome": "환영합니다",
    "auth.signIn": "계정에 로그인",
    "auth.email": "이메일",
    "auth.password": "비밀번호",
    "auth.loginButton": "로그인",
    
    // Navigation
    "nav.dashboard": "대시보드",
    "nav.releases": "릴리스",
    "nav.payouts": "지급",
    "nav.support": "지원",
    "nav.referrals": "추천",
    "nav.profile": "프로필",
    
    // Dashboard
    "dashboard.welcome": "환영합니다",
    "dashboard.subtitle": "음악을 관리하고, 릴리스를 추적하고, 수익을 확인하세요.",
    "dashboard.totalReleases": "총 릴리스",
    "dashboard.totalTracks": "총 트랙",
    "dashboard.balance": "현재 잔액",
    "dashboard.withdrawable": "인출 가능",
    "dashboard.recentReleases": "최근 릴리스",
    "dashboard.newRelease": "새 릴리스",
    "dashboard.requestPayout": "지급 요청",
    
    // Analytics
    "analytics.title": "통계",
    "analytics.subtitle": "릴리스 성과 추적",
    "analytics.totalStreams": "총 스트리밍",
    "analytics.listeners": "청취자",
    "analytics.estimatedEarnings": "예상 수익",
    "analytics.monthlyGrowth": "월별 성장",
    "analytics.streamsChart": "스트리밍 차트",
    "analytics.platformDistribution": "플랫폼 분포",
    "analytics.topTracks": "인기 트랙",
    "analytics.trackName": "트랙명",
    "analytics.streams": "스트리밍",
    "analytics.comingSoonTitle": "곧 출시",
    "analytics.comingSoonDesc": "상세한 분석과 통계가 곧 제공됩니다. artist.tools 연동을 통해 모든 플랫폼 데이터를 한 곳에서 추적할 수 있습니다.",
    "common.comingSoon": "곧 출시",
    
    // Payouts
    "payouts.title": "수익 관리",
    "payouts.subtitle": "음악 수익을 쉽게 인출하세요. 최소 $50부터 지급을 요청할 수 있습니다.",
    "payouts.fastPayment": "빠른 결제",
    "payouts.secureTransfer": "안전한 송금",
    "payouts.totalBalance": "총 잔액",
    "payouts.withdrawableBalance": "인출 가능 금액",
    "payouts.requestPayout": "지급 요청",
    "payouts.payoutHistory": "지급 내역",
    "payouts.noPayouts": "아직 지급 요청이 없습니다",
    "payouts.noPaymentMethod": "결제 수단 없음",
    "payouts.addMethodDesc": "수익을 인출하려면 결제 수단을 추가하세요.",
    "payouts.addMethod": "결제 수단 추가",
    "payouts.changeMethodVerification": "현재 결제 수단을 변경하려면 이메일 인증이 필요합니다",
    "payouts.availableBalance": "사용 가능 잔액",
    "payouts.pendingBalance": "대기 중 잔액",
    "payouts.withdrawalHistory": "인출 내역",
    "payouts.requestWithdrawal": "인출 요청",
    "payouts.minWithdrawal": "최소 인출: $50",
    "payouts.manageEarnings": "수익 관리",
    "payouts.createRequest": "지급 요청 생성",
    "payouts.amount": "금액",
    "payouts.accountHolder": "계좌 소유자",
    "payouts.bankName": "은행명",
    "payouts.minAmount": "최소 인출 금액은 $50입니다",
    "payouts.insufficientBalance": "잔액 부족",
    "payouts.fillRequired": "모든 필수 항목을 입력하세요",
    "payouts.requestCreated": "지급 요청이 생성되었습니다",
    "payouts.requestFailed": "요청 실패",
    "payouts.minNotMet": "최소 금액 미달",
    "payouts.minNotMetMsg": "지급을 요청하려면 최소 $50의 인출 가능 잔액이 필요합니다.",
    "payouts.statusRequested": "요청됨",
    "payouts.statusPaid": "지급 완료",
    "payouts.paymentMethod": "결제 수단",
    "payouts.bankTransfer": "은행 송금",
    "payouts.paypalEmail": "PayPal 이메일",
    "payouts.paypalNote": "PayPal 계정에 연결된 이메일 주소를 입력하세요",
    "payouts.fillPaypalRequired": "PayPal 이메일과 계좌 소유자 이름을 입력하세요",
    "payouts.selectCountry": "국가 선택",
    "payouts.tabProfile": "결제 프로필",
    "payouts.tabMethod": "결제 수단",
    "payouts.tabRequests": "인출 요청",
    "payouts.requirements": "인출 요건",
    "payouts.completeProfile": "결제 프로필을 완성하세요 (신원 및 주소)",
    "payouts.addPaymentMethod": "결제 수단을 추가하세요 (은행 또는 PayPal)",
    "payouts.verifyPaymentMethod": "결제 수단을 확인하세요",
    "payouts.profileComplete": "완료됨",
    "payouts.savedProfile": "저장된 프로필 정보",
    "payouts.fullName": "성명",
    "payouts.phoneNumber": "전화번호",
    "payouts.location": "위치",
    "payouts.profileType": "프로필 유형",
    "payouts.individual": "개인",
    "payouts.business": "기업/회사",
    "payouts.edit": "편집",
    
    // Statuses
    "status.draft": "초안",
    "status.submitted": "제출됨",
    "status.approved": "승인됨",
    "status.rejected": "거부됨",
    "status.live": "라이브",
    
    // Validation
    "validation.audioRequired": "오디오 파일은 필수입니다",
    "validation.audioFormatWav": "오디오 파일은 WAV 또는 FLAC 형식이어야 합니다",
    "validation.titleRequired": "제목은 필수입니다",
    "validation.titleLanguageRequired": "제목 언어는 필수입니다",
    "validation.primaryArtistRequired": "최소 한 명의 주 아티스트가 필요합니다",
    "validation.primaryGenreRequired": "주요 장르 선택은 필수입니다",
    "validation.explicitRequired": "콘텐츠 유형 선택은 필수입니다",
    "validation.coverRequired": "커버 이미지는 필수입니다",
    "validation.songwriterRequired": "최소 한 명의 작곡가가 필요합니다",
    "validation.contributorRequired": "최소 한 명의 기여자가 필요합니다",
    "validation.productionTeamRequired": "최소 한 명의 제작팀 멤버가 필요합니다",
    "validation.platformRequired": "최소 하나의 플랫폼을 선택해야 합니다",
    "validation.releaseDateRequired": "출시일은 필수입니다",
    "validation.trackCountRequired": "EP/앨범에는 최소 2곡이 필요합니다",
    "releases.track": "트랙",
    
    // Toast Messages
    "toast.saveSuccess": "저장되었습니다",
    "toast.saveFailed": "저장에 실패했습니다",
    "toast.deleteSuccess": "삭제되었습니다",
    "toast.uploadSuccess": "업로드되었습니다",
    "toast.submitSuccess": "제출되었습니다",
    "toast.loginSuccess": "로그인되었습니다",
    "toast.copySuccess": "클립보드에 복사되었습니다",
    "toast.errorOccurred": "오류가 발생했습니다",
    "toast.pleaseFixErrors": "이 섹션의 오류를 수정하세요",
    
    // Spotify
    "spotify.comingSoon": "곧 출시",
};

export default ko;
